export default __webpack_public_path__ + "static/media/NH002.358ff38d.jpg";